// extracted by mini-css-extract-plugin
export var speaker = "style-module--speaker--bb4ff";
export var speaker_col = "style-module--speaker_col--c3923";
export var speaker_colDesc = "style-module--speaker_col-desc--99277";
export var speaker_colIcon = "style-module--speaker_col-icon--15562";
export var speaker_colLeft = "style-module--speaker_col--left--4144a";
export var speaker_colList = "style-module--speaker_col-list--5e142";
export var speaker_colName = "style-module--speaker_col-name--f9cb9";
export var speaker_colRight = "style-module--speaker_col--right--9e326";
export var speaker_row = "style-module--speaker_row--31b06";